import { FC } from 'react';
import { Container } from './CoinPriceContainer.styles';
import { CoinPriceContainerProps } from './CoinPriceContainer.types';

export const CoinPriceContainer: FC<CoinPriceContainerProps> = ({ children }) => {
  return <Container>{children}</Container>;
};
